import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { JwtHelperService } from "@auth0/angular-jwt";
import moment from 'moment';
import { BroadcastService } from "./broadcast.service";

// import { BsModalService } from 'ngx-bootstrap/modal';
// import { BsModalRef } from 'ngx-bootstrap';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


// import { TermandconditionsComponent } from "../screens/shared/termandconditions/termandconditions.component";

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    public jwtHelper = new JwtHelperService();
    private currentUserSubject: BehaviorSubject<any>;
    public currentUser: Observable<any>;
    // bsModalRef: BsModalRef;

    constructor(
        private http: HttpClient,
        private broadcastService: BroadcastService,
       
        // private modalService: BsModalService,
        private router: Router,) {
        var token = this.getToken()
        // console.log(token,'currentUserSubject')
        if (token) {
            token = JSON.parse(token)
            this.currentUserSubject = new BehaviorSubject<any>(token);
            this.currentUser = this.currentUserSubject.asObservable();
        }
        else {
            this.currentUserSubject = new BehaviorSubject<any>(null);
            this.currentUser = this.currentUserSubject.asObservable();
        }
    }


    forgotPassword(email: string) {
        var formData: any = new FormData();
        formData.append("email", email);
        return this.http.post<any>(`${environment.apiUrl}login/forgot_password`, formData)
            .pipe(map(response => {
                return response;
            }));
    }
    resetPassword(email: string, temppassword: string, newpassword: string, confirmpassword: string) {
        var formData: any = new FormData();
        formData.append("email", email);
        formData.append("temppassword", temppassword);
        formData.append("newpassword", newpassword);
        formData.append("confirmpassword", confirmpassword);
        return this.http.post<any>(`${environment.apiUrl}login/reset_password`, formData)
            .pipe(map(response => {
                return response;
            }));
    }


    refreshToken() {
        return this.http.post<any>(`${environment.apiUrl}students/refreshToken`, {})
            .toPromise().then(data => {
                // login successful if there's a jwt token in the response
                if (data && data.token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    this.setToken(JSON.stringify(data.token));
                    this.currentUserSubject.next(data);
                    const profile = this.jwtHelper.decodeToken(data.token);
                    this.broadcastService.sendMessage({ type: 'profile', message: profile });
                }
                return data.token;
            });
    }

    isLogin() {
        const token = this.getToken();
        return !!token;
    }

    setToken(token) {
        localStorage.setItem('currentUser', token);
        localStorage.setItem('profile', JSON.stringify(this.jwtHelper.decodeToken(token)));
    }
    getProfile() {
        const profile = localStorage.getItem('profile');
        return profile ? JSON.parse(profile) : {};
    }

    getToken() {
        return localStorage.getItem('currentUser');
    }

    isTokenExpired() {
        const profile = this.getProfile();
        const tokenTimmeStamp = profile ? profile.expiry_time : undefined;
        if (!tokenTimmeStamp) {
            return true;
        }
        const tokenDate = moment.unix(tokenTimmeStamp);
        const tokenDateParsed = moment(tokenDate);

        const currentDate = moment();
        return (tokenDateParsed.diff(currentDate, 'seconds') < 0);
    }
    getTermConditions(token1) {
        var formData: any = new FormData();
        formData.append("token", token1);
        const headers = new HttpHeaders().set('authorization', token1)
        return this.http.post<any>(`${environment.apiUrl}login/term_accept_flag_update`, formData, { 'headers': headers })
            .pipe(map(response => {
                return response;
            }));

    }
}